import { render, staticRenderFns } from "./Dd2faModal.vue?vue&type=template&id=1624d7ac"
import script from "./Dd2faModal.vue?vue&type=script&lang=js"
export * from "./Dd2faModal.vue?vue&type=script&lang=js"
import style0 from "./Dd2faModal.vue?vue&type=style&index=0&id=1624d7ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports